import _asyncToGenerator from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/regenerator/index.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { HttpRequest } from "@smithy/protocol-http";
import { getSkewCorrectedDate } from "../utils";
import { AwsSdkSigV4Signer, validateSigningProperties } from "./AwsSdkSigV4Signer";
export var AwsSdkSigV4ASigner = /*#__PURE__*/function (_AwsSdkSigV4Signer) {
  _inherits(AwsSdkSigV4ASigner, _AwsSdkSigV4Signer);
  var _super = _createSuper(AwsSdkSigV4ASigner);
  function AwsSdkSigV4ASigner() {
    _classCallCheck(this, AwsSdkSigV4ASigner);
    return _super.apply(this, arguments);
  }
  _createClass(AwsSdkSigV4ASigner, [{
    key: "sign",
    value: function () {
      var _sign = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(httpRequest, identity, signingProperties) {
        var _config$sigv4aSigning, _ref;
        var _yield$validateSignin, config, signer, signingRegion, signingRegionSet, signingName, configResolvedSigningRegionSet, multiRegionOverride, signedRequest;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (HttpRequest.isInstance(httpRequest)) {
                  _context.next = 2;
                  break;
                }
                throw new Error("The request is not an instance of `HttpRequest` and cannot be signed");
              case 2:
                _context.next = 4;
                return validateSigningProperties(signingProperties);
              case 4:
                _yield$validateSignin = _context.sent;
                config = _yield$validateSignin.config;
                signer = _yield$validateSignin.signer;
                signingRegion = _yield$validateSignin.signingRegion;
                signingRegionSet = _yield$validateSignin.signingRegionSet;
                signingName = _yield$validateSignin.signingName;
                _context.next = 12;
                return (_config$sigv4aSigning = config.sigv4aSigningRegionSet) === null || _config$sigv4aSigning === void 0 ? void 0 : _config$sigv4aSigning.call(config);
              case 12:
                configResolvedSigningRegionSet = _context.sent;
                multiRegionOverride = ((_ref = configResolvedSigningRegionSet !== null && configResolvedSigningRegionSet !== void 0 ? configResolvedSigningRegionSet : signingRegionSet) !== null && _ref !== void 0 ? _ref : [signingRegion]).join(",");
                _context.next = 16;
                return signer.sign(httpRequest, {
                  signingDate: getSkewCorrectedDate(config.systemClockOffset),
                  signingRegion: multiRegionOverride,
                  signingService: signingName
                });
              case 16:
                signedRequest = _context.sent;
                return _context.abrupt("return", signedRequest);
              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      function sign(_x, _x2, _x3) {
        return _sign.apply(this, arguments);
      }
      return sign;
    }()
  }]);
  return AwsSdkSigV4ASigner;
}(AwsSdkSigV4Signer);